import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  border?: boolean;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  /** Clickable card: adds a subtle hover-lift/press micro-interaction. */
  interactive?: boolean;
}
const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  shadow = 'sm',
  border = true,
  rounded = 'lg',
  interactive = false,
  ...props
}) => {
  // Padding classes
  const paddingClasses = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  // Shadow classes — design elevations e1/e2/e3 (STYLEGUIDE.md §4)
  const shadowClasses = {
    none: 'shadow-none',
    sm: 'shadow-e1',
    md: 'shadow-e2',
    lg: 'shadow-e3'
  };
  // Rounded classes
  const roundedClasses = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    full: 'rounded-full'
  };
  // Border class
  const borderClass = border ? 'border border-ink-200' : '';
  // Opt-in micro-interaction for clickable cards (honours reduced-motion via index.css)
  const interactiveClass = interactive
    ? 'transition-all duration-150 hover:shadow-e2 hover:-translate-y-px active:translate-y-0 cursor-pointer'
    : '';
  // Combine all classes
  const cardClasses = `
    bg-white
    ${paddingClasses[padding]}
    ${shadowClasses[shadow]}
    ${roundedClasses[rounded]}
    ${borderClass}
    ${interactiveClass}
    ${className}
  `;
  return <div className={cardClasses} {...props}>{children}</div>;
};
export default Card;